export default "__VITE_ASSET__a7b75ae5__"